import portsApi from '@/framework/ports/portsApi';

const MyAccount = {
  openSelfExclusion: (iosRedirectUrl: string) =>
    portsApi.invoke('MyAccount.selfExclusionOpen', [iosRedirectUrl]),
};

export default MyAccount;
